class Clone {
    static _copy(source, deep = null) {
        let obj;
        let prop;
        let type;

        if(typeof source !== 'object' || source === null) {
            obj = source;
            return obj;
        }

        obj = new source.constructor();

        for(prop in source) {

            if(source.hasOwnProperty(prop)) {
                type = typeof source[prop];

                if(deep && type === 'object' && source[prop] !== null) {
                    obj[prop] = this._copy(source[prop]);
                }
                else {
                    obj[prop] = source[prop];
                }
            }
        }
        return obj;
    }

    /**
     * Copy the object without the reference.
     */
    static object(source, deep = null) {
        return this._copy(source, deep);
    }
}

export default Clone;
